import React from 'react';

type ContentBlock = {
    key: string;
    condition: boolean;
    render: () => React.ReactNode;
};

interface GetContentBlocksParams {
    content: { [key: string]: object | object[] | null } | null;
    contentBlocks: ContentBlock[];
    textContentKey?: string;
    textContentOrderNumber?: number;
}

export function getContentBlocks({
  content,
  contentBlocks,
  textContentKey,
  textContentOrderNumber = 0
}: GetContentBlocksParams): ContentBlock[] {
  if (!content) return [];

  // Определяем порядок ключей из content
  const contentOrder = Object.keys(content);
  if (textContentKey && contentBlocks.find(block => block.key === textContentKey)) {
    contentOrder.splice(textContentOrderNumber, 0, textContentKey);
  }
  // Фильтруем только те блоки, у которых condition true
  const filteredBlocks = contentBlocks.filter(block => block.condition);

  // Сортируем согласно порядку ключей в content
  const sortedBlocks = filteredBlocks.sort((a, b) => {
    const aIndex = contentOrder.indexOf(a.key);
    const bIndex = contentOrder.indexOf(b.key);
    return aIndex - bIndex;
  });

  return sortedBlocks;
}
